module.exports = "- Use Icons to show pictures.\n- Use photos or long sentences as icons.\n"